import React from 'react';
import { graphql } from 'gatsby';
import styled from 'styled-components';
import colors from '../styles/colors';
import PageLayout from '../components/Layout';
import HeroHeader from '../components/Hero';
import Form from '../components/Form/Form';
import { Link } from 'gatsby';
import SpotLight from '../components/Spotlight/Spotlight';
import IndustryBadges from '../components/IndustryBadges/IndustryBadges';
import { Helmet } from 'react-helmet';
import favicon16 from "../images/favicons/favicon-16x16.png";
import favicon32 from "../images/favicons/favicon-32x32.png";
import favicon96 from "../images/favicons/favicon-96x96.png";
import { Container, Row, Col } from "react-bootstrap"

const faviconInfo = [
  { rel: 'icon', type: 'image/png', sizes: "16x16", href: `${favicon16}` },
  { rel: 'icon', type: 'image/png', sizes: "32x32", href: `${favicon32}` },
  { rel: 'shortcut icon', type: 'image/png', href: `${favicon96}` },
];

const PageContent = ({ heroImage, className, content }) => (
    <div className={className}>
  <Container fluid> 
      <Helmet link={faviconInfo}>
        <title>Home</title>
      </Helmet>
      <Row>
        <Col xs={12} sm={12}>
        <HeroHeader
          heroImage={heroImage}
          content={content.company}
          content2={content.second}
        />
        </Col>
        </Row>
      <Row>
        <div className='page-content'>
          <Col xs={12} sm={12} md={9}>
            <div className='column'>
              <SpotLight content={content.spotlight} />
              <div className='home-content'>
                {content.home.bodyText.map((text, index) => (
                  <p key={index}>{text}</p>
                ))}
                <Link className='home-button' to='/who-we-are/'>
                  {content.home.button} &raquo;
                </Link>
                <IndustryBadges />
              </div>
            </div>
          </Col>
          <Col xs={12} sm={12} md={3}>
            {/* <div className='column'> */}
              <Form className='form' />
            {/* </div> */}
          </Col>
        </div>
      </Row>
  </Container>
    </div>
);

const StyledPageContent = styled(PageContent)`
  width: 100%;
  .page-content {
    @media screen and (min-width: 768px) {
      display: flex;
    }
    align-items: stretch;

    .home-button {
      background-color: transparent;
      text-transform: uppercase;
      align-self: flex-start;
      border: 1px solid ${colors.darkGray};
      color: ${colors.darkGray};
      padding: 5px;
      text-decoration: none;
      vertical-align: middle;
    }
  }

  .container {
    width: 100%;
  }

  .column {
    background: #ffffff;
  }

  .home-content {
    display: flex;
    flex-direction: column;
    padding: 40px;
    color: ${colors.copyColor};
  }
`;

const IndexPage = ({ data, content }) => (
  <PageLayout>
    <StyledPageContent
      heroImage={data.header.childImageSharp.fluid}
      content={content}
    />
  </PageLayout>
);

export const query = graphql`
  query {
    header: file(relativePath: { eq: "hero-home.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1200) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
  }
`;

export default IndexPage;
